import { CreditScore } from '@mui/icons-material';
import { Alert, AlertTitle, Box, Button, Divider, FormControl, FormControlLabel, Radio, RadioGroup, Stack } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { DistrictAndAssociationPicker } from 'src/shared/components/form/districtAndAssociatonPicker';

type MemberCreateModeSelectorProps = {
  payingMember: boolean | undefined;
  // Egen frågetext, till exempel för vänmedlemskap. Utan den ställs frågan om medlemmen.
  question?: string;
  payingMemberCallback: (val: boolean | undefined) => void;
  showAssociation: boolean;
  associationCallback: (val: number | undefined) => void;
};

export const MemberCreateModeSelector = (props: MemberCreateModeSelectorProps) => {
  const { payingMember, question = undefined, payingMemberCallback, showAssociation, associationCallback } = props;
  const { t } = useTranslation(['member']);

  return (
    <>
      <Alert color='info' icon={<CreditScore />}>
        <AlertTitle sx={{ mb: 1 }}>{question || t('member:createMember.hasPaymentQuestion')}</AlertTitle>
        <FormControl>
          <RadioGroup>
            <Stack spacing={1} direction='row'>
              <Button onClick={() => payingMemberCallback(true)} variant='contained' color='primary' disableElevation>
                <FormControlLabel
                  control={
                    <Radio
                      checked={payingMember !== undefined && payingMember}
                      sx={{
                        color: (thm) => thm.palette.primary.contrastText,
                        '&.Mui-checked': {
                          color: (thm) => thm.palette.primary.contrastText,
                        },
                      }}
                    />
                  }
                  label={t('member:createMember.payment.yes')}
                />
              </Button>
              <Button onClick={() => payingMemberCallback(false)} variant='outlined' color='primary' disableElevation>
                <FormControlLabel
                  control={<Radio checked={payingMember !== undefined && !payingMember} />}
                  label={t('member:createMember.payment.no')}
                />
              </Button>
            </Stack>
          </RadioGroup>
        </FormControl>
      </Alert>
      {showAssociation && (
        <>
          <Divider />
          <Box sx={{ p: 3 }}>
            <DistrictAndAssociationPicker callback={(x) => associationCallback(x)} />
          </Box>
        </>
      )}
    </>
  );
};
